import { useEffect, useRef, useState } from "react";

export const LEGAL_ROUTES = {
  "/legal": "index", "/privacy": "privacy", "/terms": "terms", "/risk-disclosure": "risk-disclosure",
  "/aml-cft-kyc": "aml-cft-kyc", "/support": "support", "/providers": "providers", "/security": "security", "/fees": "fees",
};

/** Renders a static legal page (public/legal-pages) unchanged, sized to its content. */
export default function LegalPage({ page }) {
  const frame = useRef(null);
  const [height, setHeight] = useState(1200);
  const observer = useRef(null);

  useEffect(() => {
    const previousTitle = document.title;
    return () => {
      document.title = previousTitle;
      observer.current?.disconnect();
    };
  }, []);

  useEffect(() => window.scrollTo(0, 0), [page]);

  useEffect(() => {
    const fit = () => {
      const body = frame.current?.contentDocument?.body;
      if (body) setHeight(Math.ceil(body.getBoundingClientRect().height) + 8);
    };
    window.addEventListener("resize", fit);
    return () => window.removeEventListener("resize", fit);
  }, []);

  const onLoad = () => {
    const doc = frame.current?.contentDocument;
    if (!doc?.body) return;
    if (doc.title) document.title = doc.title;
    const fit = () => setHeight(Math.ceil(doc.body.getBoundingClientRect().height) + 8);
    fit();
    observer.current?.disconnect();
    observer.current = new ResizeObserver(fit);
    observer.current.observe(doc.body);
  };

  return (
    <div data-testid={`legal-page-${page}`} className="w-full">
      <iframe ref={frame} title={`legal-${page}`} src={`/legal-pages/${page}.html`} onLoad={onLoad}
        style={{ height }} className="w-full block border-0" />
    </div>
  );
}
